import { useEffect } from "react";
import { useModelStore } from "../store/useModelStore";

export const useDocumentTitle = () => {
  const projectName = useModelStore((state) => state.projectName);

  useEffect(() => {
    document.title = `Fema - ${projectName}`;
  }, [projectName]);
};
